const localeEn = {
  // Error view
  UDE_CAREERS_ERROR: 'An error occurred while fetching your careers',
  // Career card
  UDE_CAREER_COMPLETED: 'Career completed',
};
export default localeEn;
